export const company = {
  name: 'Daxesh Petrochem',
  legalName: 'Daxesh Petrochem Pvt. Ltd.',
  shortName: 'Daxesh',
  tagline: 'Your Trusted Partner in Petrochemicals',
  foundedYear: 1986,
  since: 'Excellence Since 1986',
  email: 'admin@daxeshpetrochem.co.in',
  phones: ['+91 79849 00053', '+91 94268 00003'],
  address: {
    line1: 'Plot No. 4715, G.I.D.C. Estate',
    line2: 'Ankleshwar - 393002',
    line3: 'Dist. Bharuch, Gujarat, India',
    full: 'Plot No. 4715, G.I.D.C. Estate, Ankleshwar - 393002, Dist. Bharuch, Gujarat, India',
  },
  socials: {
    linkedin: '#',
  },
  productGuide: {
    fileName: 'DDPL-PRODUCT-GUIDE.pdf',
    fileUrl: '/brochures/DDPL-PRODUCT-GUIDE.pdf',
  },
} as const;

export type Company = typeof company;
